import { createInteriorRoomCalculator } from "./interior-room-shared.js";

/**
 * Family Room (Phase 13A). Same shared category set as living room, but
 * priced as its own project type throughout (distinct base cost and its
 * own pricing catalog entries - see interior-room-shared.ts). Family
 * room's unique addition is an optional wet bar, reflecting its common
 * use as a media/entertaining space rather than living room's more
 * formal fireplace focal point.
 */
export const calculateFamilyRoom = createInteriorRoomCalculator({
  projectType: "family_room",
  anchorItemId: "family_room_base_renovation",
  tierFeatures: [
    {
      answerKey: "family_room_flooring_type",
      itemIdByTier: { not_changing: null, basic: "family_room_flooring_basic", mid_range: "family_room_flooring_mid", premium: "family_room_flooring_premium" },
      quantityFromSqft: true,
      excludedMessage: "Flooring is not changing - excluded from this estimate."
    },
    {
      answerKey: "family_room_painting",
      itemIdByTier: { not_included: null, walls_only: "family_room_painting_walls", full_room: "family_room_painting_full" },
      quantityFromSqft: true,
      excludedMessage: "Painting was not included - excluded from this estimate."
    },
    {
      answerKey: "family_room_trim",
      itemIdByTier: { keep_existing: null, standard_upgrade: "family_room_trim_standard", premium_millwork: "family_room_trim_premium" },
      excludedMessage: "Trim/millwork is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "family_room_lighting",
      itemIdByTier: { keep_existing: null, standard_swap: "family_room_lighting_standard", statement_lighting: "family_room_lighting_statement" },
      excludedMessage: "Lighting is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "family_room_built_ins",
      itemIdByTier: { none: null, standard: "family_room_built_ins_standard", custom: "family_room_built_ins_custom" },
      excludedMessage: "No built-in media wall cabinetry was requested - excluded from this estimate."
    },
    {
      answerKey: "family_room_windows_doors",
      itemIdByTier: { none: null, replace_existing: "family_room_windows_doors_replace", add_new: "family_room_windows_doors_add" },
      excludedMessage: "No window or door changes were requested - excluded from this estimate."
    }
  ],
  booleanFeatures: [
    { answerKey: "family_room_wet_bar", itemId: "family_room_wet_bar", excludedMessage: "A wet bar was not requested - excluded from this estimate." }
  ],
  electricalItemId: "family_room_electrical",
  demolitionItemId: "family_room_demolition",
  accessibilityItemId: "family_room_accessibility",
  permitDesignItemId: "family_room_permit_design"
});
